import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LogOffService } from '../services/index';

import { APRIMA_HTTP_CONTEXT_DISABLE_UNAUTHORIZED_REDIRECT } from './context-tokens';

@Injectable()
export class UnauthorizedRedirectInterceptor implements HttpInterceptor {
  constructor(
    private logOffService: LogOffService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const disabled = req.context.get(APRIMA_HTTP_CONTEXT_DISABLE_UNAUTHORIZED_REDIRECT);

    if (disabled) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.logOffService.logoffFromUnauthorizedResponse();
          }
        },
      }),
    );
  }
}
